// extracted by mini-css-extract-plugin
export default {"loading":"BouncingLoader_loading__MVNQW","bounceball":"BouncingLoader_bounceball__A-Bcm","bounce":"BouncingLoader_bounce__UzPPA","loading-text":"BouncingLoader_loading-text__JKYxP"};